import { useState } from "react";
import ReactDOM from "react-dom";
import ConfirmationModal from "../../components/modal/ConfirmationModal";

export default function useConfirmToast() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [confirmText, setConfirmText] = useState("Yes, Delete");
  const [resolver, setResolver] =
    useState<((value: boolean) => void) | null>(null);

  const confirm = (
    msg: string,
    options?: { confirmText?: string }
  ) => {
    setMessage(msg);
    setConfirmText(options?.confirmText || "Yes, Delete");
    setIsOpen(true);

    return new Promise<boolean>((resolve) => {
      setResolver(() => resolve);
    });
  };

  const handleClose = (value: boolean) => {
    setIsOpen(false);
    resolver?.(value);
  };

  const modal = isOpen
    ? ReactDOM.createPortal(
        <ConfirmationModal
          title={message}
          confirmText={confirmText}
          cancelText="Cancel"
          onConfirm={() => handleClose(true)}
          onClose={() => handleClose(false)}
        />,
        document.getElementById("confirm-root")!
      )
    : null;

  return { confirm, modal };
}
